import { __assign, __makeTemplateObject, __read, __rest } from "tslib";
import React, { forwardRef, useMemo, useRef, useState } from 'react';
import clsx from 'clsx';
import isString from 'lodash/isString';
import { combineProps, styled, useForkRef, useOverflow, useThemeProps, } from '../../foundation';
import { RcTypography } from '../Typography';
import { highlightClassName, textStyle } from './styles';
var _RcText = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcText' });
    var children = props.children, classNameProp = props.className, flexFull = props.flexFull, highlight = props.highlight, title = props.title, titleWhenOverflow = props.titleWhenOverflow, useRcTooltip = props.useRcTooltip, TooltipPropsProp = props.TooltipProps, rest = __rest(props, ["children", "className", "flexFull", "highlight", "title", "titleWhenOverflow", "useRcTooltip", "TooltipProps"]);
    var _a = __read(useState(true), 2), isShowTitle = _a[0], setIsShowTitle = _a[1];
    var innerRef = useRef(null);
    var textRef = useForkRef(innerRef, ref);
    // * here put hook in if else, titleWhenOverflow not change any more
    if (titleWhenOverflow) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useOverflow(innerRef, function (state) { return setIsShowTitle(state); });
    }
    var className = useMemo(function () {
        var _a;
        return clsx(classNameProp, (_a = {}, _a[highlightClassName] = highlight, _a));
    }, [classNameProp, highlight]);
    var TooltipProps = useMemo(function () {
        return combineProps({
            tooltipForceHide: !isShowTitle,
        }, TooltipPropsProp);
    }, [TooltipPropsProp, isShowTitle]);
    return (React.createElement(RcTypography, __assign({ ref: textRef, title: isShowTitle || useRcTooltip // * if useRcTooltip always keep title pass into
            ? // * if user pass title, use title first
             title !== null && title !== void 0 ? title : (isString(children) ? children : undefined) : undefined, TooltipProps: TooltipProps, useRcTooltip: useRcTooltip, variant: highlight ? 'inherit' : undefined, component: highlight ? 'span' : undefined, className: className }, rest), children));
});
/**
 * `RcText` will auto add title with children when that children is string
 *  and the default wrap is noWrap,
 *  also bring with show title only when overflow
 */
var RcText = styled(_RcText)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), textStyle);
RcText.defaultProps = {
    noWrap: true,
};
export { RcText };
var templateObject_1;
